import { render, staticRenderFns } from "./Paketlemeislemi.vue?vue&type=template&id=2d8f7ba4"
import script from "./Paketlemeislemi.vue?vue&type=script&lang=js"
export * from "./Paketlemeislemi.vue?vue&type=script&lang=js"
import style0 from "./Paketlemeislemi.vue?vue&type=style&index=0&id=2d8f7ba4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports